module.exports = __webpack_public_path__ + "static/img/9.1da16f4b.jpg";